import React from 'react';
import { AuthProvider } from './AuthProvider';
import { TransactionProvider } from './TransactionProvider';

function AppContextProvider({ children }) {
  return (
    <AuthProvider>
      <TransactionProvider>{children}</TransactionProvider>
    </AuthProvider>
  );
}

export default AppContextProvider;
